<form #editBillingForm="ngForm"
  bdoScrollToInvalidControl
  [bdoScrollToInvalidControlForm]="editBillingForm"
  (ngSubmit)="saveBilling()"
  [attr.aria-label]="'aria.form.billingEdit' | translate">
  <div class="re-form-item-container">
    @if (stateGlobal === LoadingState.ERROR) {
      <bdo-info-box>
        {{ 'general.error.error' | translate }}
      </bdo-info-box>
    }
    @if (detailedBillingPlan?.noChange) {
      <bdo-info-box >
        {{ 'billing.error.noChange' | translate }}
      </bdo-info-box>
    }
  </div>

  <div class="re-form-item-container">
    <div class="re-relative" [class.bdo-loading__wrapper--height]="stateGlobal === LoadingState.LOADING">
      @if (stateGlobal === LoadingState.LOADING) {
        <bdo-loading></bdo-loading>
      }
      @if (stateGlobal !== LoadingState.LOADING) {
        <div>
          @if (detailedBillingPlan && !detailedBillingPlan.noChange) {
            <div class="re-relative re-mb-3"
              >
              <div data-qa="billingDayDropdown">
                <h5 class="re-mb-30">{{ 'billing.edit.title' | translate }}</h5>
                <div class="re-form-item-container">
                  {{ 'billing.edit.changeable' | translate }}
                </div>
                <div class="bdo-form-item-container">
                  @if (curSelectedDay) {
                    <bdo-dropdown
                      [data]="billingDayDropdown"
                      [selected]="curSelectedDay"
                      [labelText]="'billing.budgetBillingDueDate' | translate"
                      (itemSelected)="curSelectedDay = $event"
                      >
                    </bdo-dropdown>
                  }
                </div>
              </div>
              @for (billingByDivision of detailedBillingPlan.billingPlanItemSet; track billingByDivision) {
                <div>
                  <hr class="re-border-t re-border-monochrome-medium-light re-my-45">
                  <bdo-billing-edit-division
                    [billingByDivision]="billingByDivision"
                    [billingPlan]="detailedBillingPlan"
                    [parentFormgroup]="formgroup"
                    [globalLoadingState]="stateGlobal"
                  ></bdo-billing-edit-division>
                </div>
              }
              @if (detailedBillingPlan?.billingPlanItemSet.length > 1) {
                <div>
                  <hr class="re-mt-45 re-mb-15 re-border-t re-border-monochrome-medium-light">
                  <div class="re-flex">
                    <span class="re-flex-grow">{{ 'billing.plan.total' | translate }}</span>
                    <span>{{newTotalAmount | currency: 'EUR'}}</span>
                  </div>
                </div>
              }
            </div>
          }
          <div class="re-mt-45 md:re-mt-60 re-mb-15 re-clear-both">
            <button class="bdo-button-primary bdo-button--text" type="submit">
              {{ 'general.action.save' | translate }}
            </button>
          </div>
          <button class="bdo-nolink" type="button" (click)="onCancel()">
            <span class="bold">{{ 'general.action.cancel' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </div>
</form>

